import React from "react";
import { APP_INFO } from "../constants/AppInfo";
const MobileApp = () => {
  return (
    <>
      {/* Mobile App
    ============================================= */}
      <section className="section pb-4">
        <div className="container">
          <div className="row">
            <div className="col-md-5 col-lg-6 text-center">
              {" "}
              <img
                className="img-fluid"
                alt=""
                src="/assets/images/mobile-app.png"
                width={300}
              />{" "}
            </div>
            <div className="col-md-7 col-lg-6">
              <h2 className="text-9 fw-600 my-4">
                Download {APP_INFO.appName}
                <br className="d-none d-lg-inline-block" />
                Mobile App Now
              </h2>
              <p className="lead">
                Download our app for the best experience and access to a wide
                range of services at your fingertips.
              </p>
              <ul>
                <li>Recharge</li>
                <li>Bill Payment</li>
                <li>Insurance, prepaid card and gift cards</li>
                <li>and much more.....</li>
              </ul>
              <div className="d-flex flex-wrap pt-2">
                {" "}
                <a href={APP_INFO.appDownloadUrl} target="_blank">
                  <img alt="" src="/assets/images/google-play-store.png" />
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Mobile App end */}
    </>
  );
};

export default MobileApp;
